import type { WorkflowHealth } from '@chatsdet/types';
import type { BadgeProps } from '@chatsdet/ui';

/** Badge variant per {@link WorkflowHealth} — shared by every surface that badges a workflow's reliability state. */
export const workflowHealthBadgeVariants: Record<WorkflowHealth, BadgeProps['variant']> = {
  failing: 'status-failed',
  degraded: 'warning',
  flaky: 'status-flaky',
  never_passed: 'secondary',
  unverified: 'secondary',
  passing: 'secondary',
  reliable: 'success',
};
